/**
 * Mock riadattati alla struttura delle API reali
 */

import * as serviceUtils from './utils';

const MOCK_DELAY_MS = 120;

const MOCK_DOCUMENTS = [
  {
    sku: '001602/1.B',
    descrizione: 'Terminale Yamaha YSR LC 80',
    compatibilita: [
      {
        type: 'moto',
        brand: 'YAMAHA',
        modello: 'YSR LC 80',
        anni: 2002,
      },
      {
        type: 'moto',
        brand: 'YAMAHA',
        modello: 'YSR LC 80',
        anni: 2003,
      },
    ],
  },
  {
    sku: '001603/2.B',
    descrizione: 'Accessorio Yamaha MT-07',
    compatibilita: [
      {
        type: 'moto',
        brand: 'YAMAHA',
        modello: 'MT-07',
        anni: 2022,
      },
      {
        type: 'moto',
        brand: 'YAMAHA',
        modello: 'MT-07',
        anni: 2023,
      },
      {
        type: 'moto',
        brand: 'YAMAHA',
        modello: 'MT-07',
        anni: 2024,
      },
    ],
  },
  {
    sku: '002100/1.B',
    descrizione: 'Accessorio Honda Africa Twin',
    compatibilita: [
      {
        type: 'moto',
        brand: 'HONDA',
        modello: 'AFRICA TWIN',
        anni: 2021,
      },
      {
        type: 'moto',
        brand: 'HONDA',
        modello: 'AFRICA TWIN',
        anni: 2022,
      },
    ],
  },
];

function delay(ms = MOCK_DELAY_MS) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function getMockCompatibilities(vehicleType) {
  return MOCK_DOCUMENTS.flatMap((document) => document.compatibilita).filter(
    (item) => !vehicleType || item.type === vehicleType,
  );
}

async function getMockBrands(vehicleType) {
  await delay();

  const buckets = serviceUtils.toBuckets(getMockCompatibilities(vehicleType).map((item) => item.brand));

  return serviceUtils.toOptions(buckets);
}

async function getMockModels(brand) {
  await delay();

  const buckets = serviceUtils.toBuckets(
    getMockCompatibilities()
      .filter((item) => item.brand === brand)
      .map((item) => item.modello),
  );

  return serviceUtils.toOptions(buckets);
}

async function getMockYears(brand, model) {
  await delay();

  const years = serviceUtils
    .unique(
      getMockCompatibilities()
        .filter((item) => item.brand === brand && item.modello === model)
        .map((item) => item.anni),
    )
    .sort((a, b) => Number(b) - Number(a));

  return serviceUtils.toOptions(
    years.map((year) => ({
      key: year,
      doc_count: 1,
    })),
  );
}

async function getMockCompatibleItems(brand, model, year) {
  await delay();

  return MOCK_DOCUMENTS.filter((document) =>
    document.compatibilita.some(
      (item) => item.brand === brand && item.modello === model && String(item.anni) === String(year),
    ),
  ).map((document) => ({
    sku: document.sku,
    descrizione: document.descrizione,
  }));
}

async function getMockCompatibleVehiclesForProduct(sku) {
  await delay();

  const document = MOCK_DOCUMENTS.find((item) => item.sku === sku) ?? MOCK_DOCUMENTS[0];

  return document.compatibilita.map(serviceUtils.normalizeVehicleCompatibility);
}

export {
  getMockCompatibleVehiclesForProduct,
  getMockCompatibleItems,
  getMockYears,
  getMockModels,
  getMockBrands,
  getMockCompatibilities,
};
